<script setup lang="ts"></script>

<template>
  {{ $t('itf.not_field_settings') }}
</template>
